(() => {
  function init(scope = document) {
    scope.querySelectorAll('[data-joe-sam-addon]').forEach(addon => {
      if (addon.dataset.initialized) return;
      addon.dataset.initialized = 'true';
      const form = addon.closest('form');
      const container = addon.closest('[data-section-type="product"]');
      if (!form || !container) return;
      addon.hidden = false;
      const check = addon.querySelector('[data-sam-check]');
      const totals = addon.querySelector('[data-sam-totals]');
      const status = addon.querySelector('[data-sam-status]');
      const cartLink = addon.querySelector('[data-sam-cart-link]');
      const variants = JSON.parse(addon.querySelector('[data-sam-joe-variants]').textContent);
      const buttons = [...form.querySelectorAll('[data-add-to-cart]')];
      let busy = false;
      let uncertain = false;
      let buttonState = [];
      const quantity = () => Math.max(1, Number(new FormData(form).get('quantity') || container.querySelector('[name="quantity"]')?.value || 1));
      const selected = () => variants.find(v => String(v.id) === String(new FormData(form).get('id')));
      const money = cents => {
        if (window.theme?.Currency?.formatMoney) {
          const el = document.createElement('span');
          el.innerHTML = window.theme.Currency.formatMoney(cents, addon.dataset.samMoneyFormat);
          return el.textContent;
        }
        return (cents / 100).toLocaleString(document.documentElement.lang || 'de-DE', { style: 'currency', currency: window.Shopify?.currency?.active || 'EUR' });
      };
      function update() {
        totals.hidden = !check.checked;
        form.querySelectorAll('.shopify-payment-button').forEach(el => el.classList.toggle('joe-sam-checkout-hidden', check.checked));
        const variant = selected();
        if (!variant) return;
        const unit = variant.price + Number(addon.dataset.samPrice);
        addon.querySelector('[data-sam-unit]').textContent = money(unit);
        addon.querySelector('[data-sam-total]').textContent = money(unit * quantity());
      }
      new MutationObserver(records => {
        if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('.shopify-payment-button') || node.querySelector?.('.shopify-payment-button'))))) update();
      }).observe(form, { childList: true, subtree: true });
      check.addEventListener('change', update);
      container.addEventListener('variantChange', () => setTimeout(update, 0));
      container.addEventListener('input', update);
      container.addEventListener('change', update);
      async function addItems(event) {
        if (!check.checked && !busy && !uncertain) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (busy || uncertain || !selected()?.available || !form.checkValidity()) return;
        busy = true;
        const data = new FormData(form);
        const item = { id: Number(data.get('id')), quantity: quantity() };
        const properties = {};
        for (const [key, value] of data.entries()) {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match) properties[match[1]] = value;
        }
        if (Object.keys(properties).length) item.properties = properties;
        if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
        const samItem = { id: Number(addon.dataset.samId), quantity: item.quantity };
        buttonState = buttons.map(button => button.disabled);
        buttons.forEach(button => { button.disabled = true; button.classList.add('btn--loading'); });
        check.disabled = true;
        status.hidden = true;
        cartLink.hidden = true;
        try {
          const root = window.Shopify?.routes?.root || '/';
          const response = await fetch(window.theme?.routes?.cartAdd || root + 'cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ items: [item, samItem] })
          });
          const result = await response.json();
          if (!response.ok || !Array.isArray(result.items) || !result.items.some(v => Number(v.variant_id || v.id) === item.id) || !result.items.some(v => Number(v.variant_id || v.id) === samItem.id)) {
            throw new Error('Unconfirmed cart result');
          }
          status.textContent = addon.dataset.samSuccess;
          status.hidden = false;
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { product: result.items.find(v => Number(v.variant_id || v.id) === item.id), addToCartBtn: buttons[0] } }));
          if (window.theme?.settings?.cartType === 'page') window.location.assign(window.theme.routes.cartPage);
        } catch {
          uncertain = true;
          status.textContent = addon.dataset.samError;
          status.hidden = false;
          cartLink.hidden = false;
        } finally {
          busy = false;
          check.disabled = uncertain;
          buttons.forEach((button, i) => { button.disabled = uncertain || buttonState[i] || !selected()?.available; button.classList.remove('btn--loading'); });
          update();
        }
      }
      form.addEventListener('submit', addItems, true);
      // Cart apps may handle the button click before the form is submitted.
      form.addEventListener('click', event => {
        const button = event.target.closest?.('[data-add-to-cart]');
        if (button && form.contains(button)) return addItems(event);
      }, true);
      update();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
